import React from 'react';
export const IconContext = React.createContext(null);